<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section class="slds-container_x-large slds-container_center">

  <acc-global-header [appName]="appName"
                     [appTitle]="appTitle"></acc-global-header>
  <acc-global-navigation [fromSession]="false"
                         [localItems]="menuItems"
                         [localOnlyMain]="true"></acc-global-navigation>

  <main class="slds-p-around_small slds-color__background_gray-1">
    <router-outlet #outlet="outlet"></router-outlet>
  </main>

  <footer class="slds-m-around_small">
    <small class="page-footer">
      <span id="page-url">{{footerUrl}}</span>
      <span id="page-status">{{footerStatus}}</span>
    </small>
  </footer>

  <acc-notification></acc-notification>
  <acc-modal></acc-modal>

  <div *ngIf="busy"
       style="position: absolute; top: 10px; left: 50%;">
    <img alt="Loading ..." id="page-busy" src="/assets/images/busy.svg" title="Loading ...">
  </div>

</section>
